export default __webpack_public_path__ + "static/CrystalIcon-89e4b57132e6832eb136e6774d7d1945.png";